module.exports = __webpack_public_path__ + "img/DiplomatiSafiran.6ed55ff2.png";